import { useMutation } from '@tanstack/react-query';
import { submitRequest } from '../../api';
import { SubmissionResult, SubmitRequestPayload } from '../../types/submission';

const SUBMIT_ERROR_MESSAGE = 'Não foi possível enviar sua solicitação. Tente novamente.';

type UseSubmitRequestResult = {
  submit: (payload: SubmitRequestPayload) => Promise<SubmissionResult | undefined>;
  isSubmitting: boolean;
  error: string | undefined;
};

export function useSubmitRequest(): UseSubmitRequestResult {
  const { mutateAsync, isPending, isError } = useMutation({
    mutationFn: (payload: SubmitRequestPayload) => submitRequest(payload),
  });

  const submit = async (payload: SubmitRequestPayload): Promise<SubmissionResult | undefined> => {
    try {
      return await mutateAsync(payload);
    } catch {
      return undefined;
    }
  };

  return { submit, isSubmitting: isPending, error: isError ? SUBMIT_ERROR_MESSAGE : undefined };
}
